import { AutoComplete } from 'antd';
import { Picker, List, InputItem, Toast, TextareaItem } from 'antd-mobile';
import React, { useEffect, useState } from 'react';
import { api } from '../../../../../common/app';

const { Item } = List;

export function getPickerData(item: any) {
    let data = [];
    if (item.check) {
        data = item?.check.map((item: string) => {
            return {
                label: item,
                value: item,
            };
        });
    }
    return data || [];
}

export const RenderSelect = (props: any) => {
    const { item, onChange, value } = props;
    const pickerData = getPickerData(item);
    return (
        <Picker
            style={{ width: "100%" }}
            data={pickerData}
            cols={1}
            value={[value]}
            onOk={(params) => {
                // changeFormValue(params[0], value);
                // setSelectedSex(params[0]);
                onChange(item, params[0]);
            }}
        >
            <Item>
                <span style={{ color: "red" }}>
                    {item.is_required ? "*" : ""}
                </span>
                {item.zh_name}:
            </Item>
        </Picker>
    );
}

export const RenderInput = (props: any) => {
    const { item, onChange, value, ...rest } = props;
    return (
        <InputItem
            placeholder={"请输入" + item.zh_name}
            // {...inputCustomProps}
            value={value}
            onChange={(text) => {
                onChange(item, text);
            }}
            {...rest}
        >
            <span style={{ color: "red" }}>{item.is_required ? "*" : ""}</span>
            {item.zh_name}:
        </InputItem>
    );
};


export const RenderTextArea = (props: any) => {
    const { item, onChange, value, ...rest } = props;
    return (
        <TextareaItem
            autoHeight
            onChange={(text) => {
                onChange(item, text);
            }}
            title={
                <div>
                    <span style={{ color: "red" }}>
                        {item.is_required ? "*" : ""}
                    </span>
                    {item.zh_name}:
                </div>
            }
            value={value}
            placeholder={"请输入" + item.zh_name}
        ></TextareaItem>
    );
};


export const RenderArea = (props: any) => {
    const { item, onChange, value, extra, ...rest } = props;
    // 联动地区地址
    const [addressPickerData, setAddressPickerData] = useState([] as any[]);
    // 请求联动地区地址
    useEffect(() => {
        (api as any)
            .getArea()
            .then((result: any) => {
                setAddressPickerData(result.result);
            })
            .catch((error: any) => {
                Toast.fail(error.message);
            });
    }, [props.meetid]);
    if (addressPickerData.length > 0) {
        return (
            <Picker
                style={{ width: "100%" }}
                extra={extra}
                value={typeof value !== "string" ? value : []}
                data={addressPickerData}
                format={(labels) => {
                    // changeFormValue(labels.join(" "), value);
                    // onChange({ en_name: 'type_area_area_info' }, labels.join(" "));
                    return labels.join(" ");
                }}
                onOk={(params) => {
                    console.log('params', params);
                    const pro = addressPickerData.find(a => a.value === params[0])
                    const city = pro && pro.children.find((p: any) => p.value === params[1]);
                    const area = city && city.children.find((c: any) => c.value === params[2]);
                    const areaInfo = [pro, city, area].filter(i => !!i).map((item) => item.label).join('');
                    onChange({ en_name: 'type_area_area_info' }, areaInfo);
                    onChange(item, params);
                }}
                cascade={true}
                cols={3}
                {...rest}
            >
                <Item>
                    <span style={{ color: "red" }}>
                        {item.is_required ? "*" : ""}
                    </span>
                省市区:
            </Item>
            </Picker>
        );
    }
    return <div />
};


export const RenderSubject = (props: any) => {
    const { item, onChange, value, extra, ...rest } = props;

    // 学科列表
    const [subjectList, setSubjectList] = useState([] as any[]);
    // 获取学科
    useEffect(() => {
        if (!!props.meetid) {
            (api as any)
                .getSubjectSpecialty({})
                .then((result: any) => {
                    setSubjectList(result.result);
                })
                .catch((error: any) => {
                    Toast.fail(error.message);
                });
        }
    }, [props.meetid]);
    return (
        <Picker
            style={{ width: "100%" }}
            extra={extra}
            value={typeof value !== "string" ? value : []}
            data={subjectList}
            onOk={(params) => {
                onChange(item, params);
            }}
            cascade={true}
            cols={2}
        >
            <Item>
                <span style={{ color: "red" }}>
                    {item.is_required ? "*" : ""}
                </span>
                学科:
            </Item>
        </Picker>
    );
};

export const RenderTechnical = (props: any) => {
    const { item, onChange, value, extra, ...rest } = props;
    // 学科列表
    const [subjectList, setSubjectList] = useState([] as any[]);
    // 获取学科
    useEffect(() => {
        if (!!props.meetid) {
            (api as any).getTechnical({})
                .then((result: any) => {
                    setSubjectList(result.result);
                })
                .catch((error: any) => {
                    Toast.fail(error.message);
                });
        }
    }, [props.meetid, item.en_name]);
    return (
        <Picker
            style={{ width: "100%" }}
            extra={extra}
            value={typeof value !== "string" ? value : []}
            data={subjectList}
            onOk={(params) => {
                onChange(item, params);
            }}
            cascade={true}
            cols={1}
        >
            <Item>
                <span style={{ color: "red" }}>
                    {item.is_required ? "*" : ""}
                </span>
                {item.zh_name}:
            </Item>
        </Picker>
    );
};

export const RenderEducation = (props: any) => {
    const { item, onChange, value, extra, ...rest } = props;

    // 学科列表
    const [subjectList, setSubjectList] = useState([] as any[]);
    // 获取学科
    useEffect(() => {
        if (!!props.meetid) {
            (api as any)
                .getEducation({})
                .then((result: any) => {
                    setSubjectList(result.result);
                })
                .catch((error: any) => {
                    Toast.fail(error.message);
                });
        }
    }, [props.meetid, item.en_name]);
    return (
        <Picker
            style={{ width: "100%" }}
            extra={extra}
            value={value}
            data={subjectList}
            format={(labels) => {
                return labels.join(" ");
            }}
            onOk={(params) => {
                onChange(item, params[0]);
            }}
            cascade={true}
            cols={1}
        >
            <Item>
                <span style={{ color: "red" }}>
                    {item.is_required ? "*" : ""}
                </span>
                {item.zh_name}:
            </Item>
        </Picker>
    );
};

export const RenderHospital = (props: any) => {
    const { item, value, pickerValue, onChange } = props;

    // 联动地区地址
    const [addressPickerData, setAddressPickerData] = useState([] as any[]);
    // 该地区的所有医院
    const [hospitalList, setHospitalList] = useState([] as any[]);

    // 请求联动地区地址
    useEffect(() => {
        (api as any)
            .getArea()
            .then((result: any) => {
                setAddressPickerData(result.result);
            })
            .catch((error: any) => {
                Toast.fail(error.message);
            });
    }, [props.meetid]);

    // 用户选择地址之后请求该地址医院
    useEffect(() => {
        if (pickerValue[2]) {
            (api as any)
                .getHospital({ area_code: pickerValue[2] })
                .then((result: any) => {
                    setHospitalList(result.result);
                })
                .catch((error: any) => {
                    Toast.fail(error.message);
                });
        }
    }, [pickerValue]);

    console.log('pickerValue', pickerValue);
    console.log('value', value);
    return (
        <div>
            <Picker
                style={{ width: "100%" }}
                extra={"请选择省/市/区"}
                value={pickerValue}
                data={addressPickerData}
                format={(labels) => {
                    return labels.join(" ");
                }}
                onOk={(params) => {
                    onChange({ en_name: 'type_hospital_province_code' }, params[0]);
                    onChange({ en_name: 'type_hospital_city_code' }, params[1]);
                    onChange({ en_name: 'type_hospital_area_code' }, params[2] || 0);
                }}
                cascade={true}
                cols={3}
            >
                <Item>
                    <span style={{ color: "red" }}>
                        {item.is_required ? "*" : ""}
                    </span>
                    医院地区:
                </Item>
            </Picker>
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    paddingLeft: "5px",
                    paddingTop: 5,
                    paddingBottom: 5,
                }}
            >
                <AutoComplete
                    bordered={false}
                    showSearch
                    style={{
                        display: "flex",
                        flex: 1,
                        color: "#888",
                        fontSize: "16px",
                        textAlign: "right",
                    }}
                    placeholder="请选择医院"
                    optionFilterProp="children"
                    value={value}
                    onChange={(key: any) => {
                        onChange(item, key);
                    }}
                    filterOption={(input: any, option: any) => {
                        return option.children.indexOf(input) >= 0;
                    }}
                >
                    {hospitalList &&
                        hospitalList.map((hitem) => {
                            return (
                                <AutoComplete.Option
                                    value={hitem.label}
                                    key={hitem.value}
                                >
                                    {hitem.label}
                                </AutoComplete.Option>
                            );
                        })}
                </AutoComplete>
            </div>
        </div>
    );
};